import _ from 'lodash'
import ProfileSnapshot from 'quick-quote/product-common/benefit-illustration/components/profile-summary/profile-snapshot'
import LegalDisclaimerMarketConduct from 'quick-quote/product-common/benefit-illustration/components/legal-disclaimer-market-conduct'
import ProductBenefits from './product-benefits/product-benefits'
import PolicyValueTable from './policy-value/policy-value-table'
import BenefitSummary from './benefit-summary-table'
import RiderBenefits from 'quick-quote/product-common/benefit-illustration/components/rider-benefits'
import { SidebarMenu } from 'quick-quote/components'
import { isNil } from 'core/service/lib/type-check'
import { FormFeedback, FormGroup } from 'reactstrap'

import { Redirect } from 'react-router-dom'
import PATH from 'quick-quote/constants/path'
import MESSAGES from 'core/data-model/constants/validation-messages'
import BIMESSAGES from 'core/data-model/constants/bi-messages'

export const summaryHeaderWithCode = ({ displayProduct, riders }) => {
  const name = _.get(displayProduct, 'displayName', '')
  const riderPlanCode = _.get(displayProduct, 'basicPlanCode', '')

  if (_.get(displayProduct, 'basicPlanCode') === '25PL') {
    return name
  }

  return `${name} (${riderPlanCode})`
}

const summaryHeader = ({ displayProduct }) => (displayProduct ? displayProduct.displayName : '')

const BenefitIllustration = ({
  displayProduct,
  riders,
  genderLabel,
  age,
  calculatedCoveragePeriod,
  calculatedPaymentPeriod,
  sumAssured$,
  basicPremium$,
  totalPremium,
  totalRiderPremium,
  selectedModelFactorLabel,
  hasNonLevelRider,
  coveragePlanStartDate,
  legalDisclaimerEndDate,
  policyValue,
  benefitSummary,
  canProceedToBenefitIllustration,
  isBlockedPdfGeneration,
  isBlockedEnteringESub,
  isReviseQQ,
}) => {
  if (!canProceedToBenefitIllustration) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  } else if (isNil(displayProduct)) return <div id="benefit-illustration-invalid" />
  else {
    return (
      <div id="benefit-illustration">
        <div className="content">
          <ProfileSnapshot
            displayProduct={displayProduct}
            riders={riders}
            genderLabel={genderLabel}
            age={age}
            calculatedCoveragePeriod={calculatedCoveragePeriod}
            calculatedPaymentPeriod={calculatedPaymentPeriod}
            policyValue={policyValue}
            sumAssured={sumAssured$.value}
            basicPremium={basicPremium$.value}
            totalPremium={totalPremium}
            totalRiderPremium={totalRiderPremium}
            selectedModelFactorLabel={selectedModelFactorLabel}
            hasNonLevelRider={hasNonLevelRider}
            profileSummaryHeader={summaryHeaderWithCode}
            summaryTableHeader={summaryHeader}
            isReviseQQ={isReviseQQ}
          />

          <ProductBenefits
            displayProduct={displayProduct}
            sumAssured={sumAssured$.value}
            basicPremium={basicPremium$.value}
            calculatedPaymentPeriod={calculatedPaymentPeriod}
            calculatedCoveragePeriod={calculatedCoveragePeriod}
            policyValue={policyValue}
            benefitSummaryHeader={({ displayProduct }) => displayProduct.nameThai}
          />

          {riders.length > 0 && <RiderBenefits />}

          <PolicyValueTable policyValue={policyValue} basicPlan={displayProduct} />
          <BenefitSummary />

          <LegalDisclaimerMarketConduct startDate={coveragePlanStartDate} endDate={legalDisclaimerEndDate} />

          {isBlockedEnteringESub ? (
            <FormGroup className="has-warning">
              <FormFeedback className={'eligibility-message attached-icon'}>
                <div> {MESSAGES.RULE_ENTER_ESUB_PREREQUISITE} </div>
              </FormFeedback>
            </FormGroup>
          ) : (
            ''
          )}
        </div>
        <SidebarMenu
          mainMenu={[
            {
              text: BIMESSAGES.SUMMARY_OF_MAIN_AND_ADDITIONAL_CONTRACTS,
              id: 'profile-summary',
              isSub: false,
            },
            {
              text: 'รายละเอียดของสัญญาหลัก',
              id: 'product-benefits',
              isSub: false,
            },
            {
              text: BIMESSAGES.POLICY_VALUE_TABLE,
              id: 'policy-value',
              isSub: false,
            },
            {
              text: BIMESSAGES.BENEFIT_SUMMARY,
              id: 'benefit-summary',
              isSub: false,
            },
            {
              text: BIMESSAGES.LEGAL_DISCLAIMER,
              id: 'legal-disclaimer-market-conduct',
              isSub: false,
            },
          ]}
        />
      </div>
    )
  }
}

export default BenefitIllustration
